import { useTracking } from "#hooks/useTracking.ts";
import { MixpanelCopyResponseType, MixpanelEvent } from "#types/tracking.ts";
import { useEffect, useRef } from "react";

interface UseCopyTrackingProps {
    conversationId: string;
    messageId: string;
}

export const useCopyTracking = ({ conversationId, messageId }: UseCopyTrackingProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const { trackEvent } = useTracking();

    useEffect(() => {
        const handleCopy = () => {
            const selection = document.getSelection();
            if (selection && selection.toString().length > 0 && contentRef.current?.contains(selection.anchorNode)) {
                trackEvent(MixpanelEvent.AssistantResponseCopied, {
                    "Conversation Id": conversationId,
                    "Message Id": messageId,
                    Type: MixpanelCopyResponseType.Manual
                });
            }
        };

        const contentElement = contentRef.current;
        contentElement?.addEventListener("copy", handleCopy);

        return () => {
            contentElement?.removeEventListener("copy", handleCopy);
        };
    }, [conversationId, messageId, trackEvent]);

    return contentRef;
};
